import { REPLACE } from '../../root/actions/_types';
import { SETUP_DATA } from '../search/actions/_types';
import { SET_LOADING, SETUP_INIT_DATA, VIEW } from './_types';

const API_URL = '/events/model';

export default async ({ rootState, dispatch }) => {
  const { search: searchParams, pathname } = rootState.root;

  const query = new URLSearchParams(searchParams);
  const path = `${API_URL}${pathname.replace(/\/events/, '')}?${query.toString()}`;

  dispatch(SET_LOADING, true);
  const res = await fetch(path);
  if (!res.ok) {
    throw Error(res.statusText);
  }
  const data = await res.json();

  // Refresh url with redirected url if needed
  if (res.redirected) {
    const { requestUriPath, queryString } = data;

    const nextQuery = new URLSearchParams(queryString);
    dispatch(REPLACE, `${requestUriPath}?${nextQuery.toString()}`, { root: true });
  }

  dispatch(`opo-search/search/${SETUP_DATA}`, data, { root: true });
  dispatch(SETUP_INIT_DATA, data);
  dispatch(VIEW);
  dispatch(SET_LOADING, false);
};
